import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const SEEN_KEY = "stellar.noteReminders.seen";
const POLL_MS = 60 * 1000;

function seenKeys() {
  try {
    return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"));
  } catch {
    return new Set();
  }
}

function remember(keys) {
  localStorage.setItem(SEEN_KEY, JSON.stringify(Array.from(keys).slice(-300)));
}

async function notify(note) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  const options = {
    body: note.content || note.title || "Erinnerung aus Stellar ERP",
    icon: "/logo192.svg",
    badge: "/logo192.svg",
    tag: `stellar-note-${note.id}-${note.reminder_at}`,
    data: { url: "/notizen" },
  };
  try {
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.ready;
      await registration.showNotification(`Erinnerung: ${note.title || "Notiz"}`, options);
    } else {
      new Notification(`Erinnerung: ${note.title || "Notiz"}`, options);
    }
  } catch {
    // System notifications may be disabled independently from the browser.
  }
}

export function useNoteNotifications({ enabled }) {
  const query = useQuery({
    queryKey: ["note-reminders-due", enabled],
    queryFn: async () => {
      const until = new Date().toISOString();
      const { data } = await api.get(`/notes/reminders/due?until=${encodeURIComponent(until)}`);
      const seen = seenKeys();
      for (const note of data) {
        const key = `${note.id}:${note.reminder_at}`;
        if (!seen.has(key)) {
          seen.add(key);
          await notify(note);
        }
      }
      remember(seen);
      return data;
    },
    enabled,
    refetchInterval: POLL_MS,
    refetchIntervalInBackground: true,
  });

  return { dueCount: query.data?.length || 0 };
}
